import React, { useState } from 'react';
import posed from 'react-pose';
import styled from 'styled-components';

const Box = posed.div({
  show: {
    opacity: 1,
    x: 0,
    y: 0,
    transition: {
      default: { duration: 300 }
    },
    applyAtStart: {
      x: 100,
      y: -50
    },
    applyAtEnd: {
      x: 0,
      y: 0
    }
  },
  hidden: {
    opacity: 0,
    x: -100,
    y: -50,
    transition: { duration: 150 }
  }
});

const Dot = styled.div`
  width: 10px;
  height: 10px;
  background: #00ffca;
  display: inline-block;
  border-radius: 5px;
  margin: 0 5px;
`;

const array = [1, 2, 3];
export default () => {
  const [num, setNum] = useState(1);

  return (
    <div onClick={() => setNum(num + 1 > 3 ? 1 : num + 1)}>
      <div
        style={{
          position: 'relative',
          height: 482,
          width: 284,
          margin: '0 auto'
        }}
      >
        {array.map(index => {
          return (
            <div key={index} style={{ position: 'absolute', top: 0 }}>
              <Box pose={index === num ? 'show' : 'hidden'}>
                <img
                  alt="mobile"
                  src={require(`../assets/images/mobile${index}.png`)}
                />
              </Box>
            </div>
          );
        })}
      </div>
      {array.map(index => {
        return <Dot key={index} />;
      })}
    </div>
  );
};
